export const TenantStatusEnum = Object.freeze(
   {
      Pending:0,
      Approved:1,
      ApprovedAndAdminAccessed:2, // After Approved, admin Also Got Accessed by settup password
      Suspended:3,
      Deleted:4
   });